import { DOC_TYPES } from "src/data/legalDocument";
import LegalDocumentPage from "src/components/legal/LegalDocumentPage";
import { useT } from "src/i18n";

export default function Kayttoehdot() {
    const t = useT();
    return (
        <LegalDocumentPage
            docType={DOC_TYPES.TOS}
            path="/kayttoehdot"
            title={t("legal.kayttoehdot.pageTitle")}
            description={t("legal.kayttoehdot.pageDescription")}
            heading={t("legal.kayttoehdot.heading")}
            loadFailedMessage={t("legal.kayttoehdot.loadFailed")}
        />
    );
}
